import { App, inject, InjectionKey, reactive, ref } from "vue";
import Loading from "@/lib/loading/component/Loading.vue";

const loading = () => {
  const isShow = ref(false);
  const state = reactive({
    isShow: isShow,
  });

  // Wait表示しつつasync実行する
  const loadWith = async <T>(f: () => Promise<T>) => {
    try {
      isShow.value = true;
      const result = await f();
      return result;
    } finally {
      isShow.value = false;
    }
  };

  return {
    state,
    loadWith,
  };
};

export default {
  install: (app: App) => {
    // プラグインのコードをここに書く
    app.component("v-wait", Loading);
    app.provide(loadingKey, loading());
  },
};

export type Loading = ReturnType<typeof loading>;
export const loadingKey: InjectionKey<Loading> = Symbol("loading");
export const useLoading = () => {
  const store = inject(loadingKey);
  if (!store) {
    throw new Error(`${loadingKey} is not provided`);
  }
  return store;
};
